import React from 'react'
import App from './src/shared/components/app'

export const wrapPageElement = ({
  element, 
  props
}) => {
  const pathName = props.location.pathname
  if (pathName.endsWith('.xml')) {
    return element
  }

  const data = props.data
  const page = data.page
  const location = props.location
  const pageContext = props.pageContext
  const ctx = {data,pageContext,location} 

  if (page && page.content) {
    data.page = JSON.parse(page.content)
  }

  return <App {...ctx}>{element}</App>
}